import React, { useState } from "react";
import "../App.css";
import bgImage from "../assets/venice-mall.jpg";
import { useNavigate } from "react-router-dom";
import { apiRequest, API_ENDPOINTS } from "../utils/api";
import { useTranslation } from "react-i18next";

export default function Login() {
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        if (!name || !password) {
            setError(t("login.errorMissing"));
            setLoading(false);
            return;
        }

        try {
            const data = await apiRequest(API_ENDPOINTS.LOGIN, {
                method: "POST",
                body: JSON.stringify({ username: name, password }),
            });

            // ✅ Store JWT + role + user info
            if (data.token) localStorage.setItem("token", data.token);
            if (data.role) localStorage.setItem("role", data.role);
            localStorage.setItem("user", JSON.stringify({
                username: data.username,
                can_use_safe: data.can_use_safe || false
            }));

            // ✅ Navigate based on role
            if (data.role === "admin") {
                alert(t("login.welcomeAdmin", { username: data.username }));
                navigate("/admin");
            } else if (data.role === "owner") {
                alert(t("login.welcomeUser", { username: data.username }));
                navigate("/owner");
            } else {
                alert(t("login.welcomeUser", { username: data.username }));
                navigate("/home");
            }
        } catch (err) {
            console.error("Login error:", err);
            setError(err.message || t("login.errorGeneric"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="background" style={{ backgroundImage: `url(${bgImage})` }}>
            <div className="overlay">
                <h1 className="logo elitehome-wordmark">
                    EliteHome
                </h1>

                <div className="login-card">
                    <h2 className="card-title">{t("login.welcomeTitle")}</h2>
                    <p className="card-subtitle">{t("login.welcomeSubtitle")}</p>

                    <form onSubmit={handleLogin}>
                        <div className="field">
                            <div className="input-wrapper">
                                <input
                                    id="username"
                                    type="text"
                                    placeholder={t("login.username")}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    autoComplete="username"
                                />
                            </div>
                        </div>

                        <div className="field">
                            <div className="input-wrapper">
                                <input
                                    id="password"
                                    type="password"
                                    placeholder={t("login.password")}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    autoComplete="current-password"
                                />
                            </div>
                        </div>

                        <div className="actions">
                            <a href="#" className="link-muted">{t("login.forgotPassword")}</a>
                        </div>

                        <button className="btn-primary" type="submit" disabled={loading}>
                            {loading ? t("login.signingIn") : t("login.signIn")}
                        </button>
                        {error && <p className="error">{error}</p>}
                    </form>
                </div>

                <p className="subtle">© {new Date().getFullYear()} EliteHome. All rights reserved.</p>
            </div>
        </div>
    );
}
